import { noop } from './utils';

const eachLimit = (arr, limit, iterator, callback) => {
  callback = callback || noop;
  if (!arr.length || limit <= 0) {
    callback();
    return;
  }

  let completed = 0;
  let started = 0;
  let running = 0;

  (function replenish() {
    if (completed >= arr.length) {
      callback();
      return;
    }

    while (running < limit && started < arr.length) {
      started += 1;
      running += 1;
      iterator(arr[started - 1], err => {
        if (err) {
          callback(err);
          callback = noop;
        } else {
          completed += 1;
          running -= 1;
          if (completed >= arr.length) {
            callback();
          } else {
            replenish();
          }
        }
      });
    }
  }());
};

const retry = (times, iterator, callback) => {
  const next = index => {
    // stop : 标记迭代是否立即停止
    iterator((err, data, stop) => {
      if (err && index < times && !stop) {
        next(index + 1);
      } else {
        callback(err, data);
      }
    });
  };
  next(1);
};

const async = {
  eachLimit,
  retry,
};

export default async;
